/**
 * Shared backend-aligned password rules.
 *
 * Mirrors the backend `class-validator` decorators on `RegisterDto`,
 * `ResetPasswordDto`, and `ChangePasswordDto`
 * (`src/auth/dto/register.dto.ts`, `src/auth/dto/reset-password.dto.ts`,
 * `src/auth/dto/change-password.dto.ts`):
 *
 *   - MinLength(8)
 *   - Matches /[A-Z]/
 *   - Matches /[0-9]/
 *
 * The regexes also drive the live ✓/✗ checklist in
 * `components/auth/PasswordRequirementsChecklist.tsx` — one source so
 * the live display and every pre-flight submit guard cannot drift.
 */

export const PASSWORD_HAS_LENGTH = /.{8,}/;
export const PASSWORD_HAS_UPPERCASE = /[A-Z]/;
export const PASSWORD_HAS_DIGIT = /[0-9]/;

export function isStrongPassword(password: string): boolean {
  return (
    PASSWORD_HAS_LENGTH.test(password) &&
    PASSWORD_HAS_UPPERCASE.test(password) &&
    PASSWORD_HAS_DIGIT.test(password)
  );
}
